import * as Types from "../action/types";

const INITIAL_STATE = {
  data: [],
  total: 0,
  loading: false,
  error: null,
};

const getEntityId = (item) => item?.id || item?._id || item;

const hasOwn = (obj, key) =>
  Object.prototype.hasOwnProperty.call(obj || {}, key);

const groupAreaReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GROUP_AREA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case Types.GROUP_AREA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Types.FETCH_GROUP_AREAS_SUCCESS:
      return {
        ...state,
        loading: false,
        data:
          action.payload?.data ??
          (Array.isArray(action.payload) ? action.payload : []),
        total:
          action.payload?.total ??
          (Array.isArray(action.payload) ? action.payload.length : 0),
      };
    case Types.CREATE_GROUP_AREA_SUCCESS: {
      const group = action.payload?.data || action.payload;
      return {
        ...state,
        loading: false,
        data: group ? [group, ...state.data] : state.data,
        total: group ? state.total + 1 : state.total,
      };
    }
    case Types.UPDATE_GROUP_AREA_SUCCESS: {
      const updatedGroup = action.payload?.data || action.payload;
      return {
        ...state,
        loading: false,
        data: state.data.map((item) => {
          if (!item || !updatedGroup) return item;
          const itemId = item.id || item._id;
          const updatedId = updatedGroup.id || updatedGroup._id;
          return itemId === updatedId ? updatedGroup : item;
        }),
      };
    }
    case Types.UPDATE_AREAS_SUCCESS: {
      const updatedArea = action.payload?.data || action.payload;
      const areaId = getEntityId(updatedArea);
      const requestData = action.meta?.requestData;
      const shouldSyncGroup =
        hasOwn(updatedArea, "groupAreaId") ||
        hasOwn(requestData, "groupAreaId");

      if (!areaId || !shouldSyncGroup) {
        return state;
      }

      const nextGroupAreaId = hasOwn(updatedArea, "groupAreaId")
        ? getEntityId(updatedArea.groupAreaId)
        : getEntityId(requestData.groupAreaId);

      return {
        ...state,
        loading: false,
        data: state.data.map((group) => {
          if (!group) return group;

          const groupId = getEntityId(group);
          const areasID = Array.isArray(group.areasID) ? group.areasID : [];
          const currentIndex = areasID.findIndex(
            (area) => getEntityId(area) === areaId,
          );
          const belongsToThisGroup = groupId === nextGroupAreaId;

          if (belongsToThisGroup && currentIndex >= 0) {
            return {
              ...group,
              areasID: areasID.map((area, index) =>
                index === currentIndex ? updatedArea : area,
              ),
            };
          }

          const areasWithoutUpdatedArea = areasID.filter(
            (area) => getEntityId(area) !== areaId,
          );

          if (!belongsToThisGroup) {
            return {
              ...group,
              areasID: areasWithoutUpdatedArea,
            };
          }

          return {
            ...group,
            areasID: [updatedArea, ...areasWithoutUpdatedArea],
          };
        }),
      };
    }
    case Types.DELETE_GROUP_AREA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((item) => item.id !== action.payload),
        total: state.total - 1,
      };
    default:
      return state;
  }
};

export default groupAreaReducer;
